import Action from '../Action';
import BannerService from '../../services/BannerService';
import { message } from 'antd';

export function searchBanner(query) {
	return (dispatch) => {
		BannerService.search(query)
			.then((banner) => {
				dispatch({ type: Action.SEARCH_BANNER, searchBanner: banner.data });
			})
			.catch((error) => message.error('Failed to search banner!'));
	};
}

export function fetchBanner() {
	return (dispatch) => {
		BannerService.get()
			.then((banner) => dispatch({ type: Action.FETCH_BANNER, banner: banner.data }))
			.catch((error) => message.error('Failed to fetch banner!'));
	};
}

export function addBanner(body) {
	return (dispatch) => {
		BannerService.add(body)
			.then((banner) => {
				dispatch({ type: Action.POST_BANNER, banner: banner.data });
				message.success('Banner Added');
			})
			.catch((error) => message.error('Failed to add banner!'));
	};
}

export function updateBanner(id, body) {
	return (dispatch) => {
		BannerService.update(id, body)
			.then((banner) => {
				dispatch({ type: Action.UPDATE_BANNER, banner: banner.data });
				message.success('Banner Updated');
			})
			.catch((error) => message.error('Failed to update banner!'));
	};
}

export function deleteBanner(id) {
	return (dispatch) => {
		BannerService.delete(id)
			.then((banner) => {
				dispatch({ type: Action.DELETE_BANNER, banner: banner.data });
				message.success('Banner Deleted');
			})
			.catch((error) => message.error('Failed to delete Banner!'));
	};
}

export function updateBannerStatus(id, body) {
	return (dispatch) => {
		BannerService.updateStatus(id, body)
			.then((image) => {
				dispatch({ type: Action.UPDATE_BANNER_STATUS, image: image.data });
				message.success('banner Image Status Updated');
			})
			.catch((error) => message.error('failed to update banner image!'));
	};
}

export function updateBannerMobile(id, body) {
	return (dispatch) => {
		BannerService.updateMobileImage(id, body)
			.then((banner) => {
				dispatch({ type: Action.UPDATE_BANNER_MOBILE_IMAGE, banner: banner.data });
				message.success('Banner Updated');
			})
			.catch((error) => message.error('Failed to update Banner!'));
	};
}

export function updateBannerWeb(id, body) {
	return (dispatch) => {
		BannerService.updateWebImage(id, body)
			.then((banner) => {
				dispatch({ type: Action.UPDATE_BANNER_WEB_IMAGE, banner: banner.data });
				message.success('Banner Image Updated');
			})
			.catch((error) => message.error('Failed to update Banner!'));
	};
}
